<template>
  <div :class="$style['pt-life-experience-pavilion-form']">
    <pt-page-title :title="isEdit?'编辑生命体验馆':'新建生命体验馆'"></pt-page-title>
    <pt-sub-title title="生命体验馆信息"></pt-sub-title>
    <table :class="$style['role-customer-basic-message']">
      <pt-form-list-item label="生命体验馆名称：" required>
        <wt-input v-model="formValue.name" v-validate="'required'" data-vv-as="生命体验馆名称" placeholder="请输入生命体验馆名称"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="所属分/子公司：" required>
          <wt-selector :options="organizationList" filterable class="branch-select" v-model="formValue.organizationId" data-vv-as="所属分/子公司" name="name" v-validate="'required'"></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="选择省市：" required>
        <pt-address-select v-model="formValue.address" required data-vv-as="所属省市" name="name"
              v-validate="'required'" ref="address" :validateText="addressValidateText" :showElement="addressShowElement"></pt-address-select>
      </pt-form-list-item>
    </table>
  </div>
</template>

<script>
import ptAddressSelect from 'cps/base/pt-address-select/withData'
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-life-experience-pavilion-form'

export default {
  name: 'pt-life-experience-pavilion-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    address () {
      return this.$refs.address
    }
  },
  components: {
    ptAddressSelect
  },
  props: {
    lifeExperienceHallsDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    organizationList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    lifeExperienceHallsDetail: {
      handler: function (val) {
        this.formValue = val
      }
    }
  },
  data () {
    return {
      formValue: {},
      addressValidateText: {
        province: '所属省',
        city: '所属市'
      },
      addressShowElement: {
        province: true,
        city: true
      }
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .menu-permissions {
    // margin-bottom: 20px;
    line-height: 40px;
  }

  .pt-life-experience-pavilion-form {
    table {
      padding: 0 20px;
    }
  }

  .role-customer-basic-message {
    max-width: 500px;
    :global{
      .branch-select{
        width: 100%
      }
    }
  }

  .org-select {
    width: 100%
  }

  .edit-password-text {
    color: red;
    font-size: 12px
  }

</style>
